
import { BasicModel } from '../basic.model';

export class ContractWork2Model {

  public id: number;
  public selected: any = new BasicModel();
  public workCodeMilo: string;
  public miloCode: string;
  public title: string;
  public titleVO: string;
  public titleWork: string;
  public yearOfProduction: string;
  public workYearProductLabel: string;
  public action: string;
  public contractId: number;
  public workRefId: number;
  public idWork: number;
  public financialAmount: number;
  public checked: boolean = false;
  public included: BasicModel[] = [];
  public excluded: BasicModel[] = [];

  constructor() {

  }

  public getAllIdExcluded(): number[] {
    return this.excluded.map((x) => x.id);
  }
  public fromJSON(json) {
    for (let propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
